@switch (invoiceState) {
  @case ('draft') {
    <span
      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-surface-hover text-fg-subtle whitespace-nowrap"
    >
      Entwurf
    </span>
  }
  @case ('ready') {
    <span
      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300 whitespace-nowrap"
    >
      Bereit
    </span>
  }
  @case ('sent') {
    <span
      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300 whitespace-nowrap"
    >
      Versendet
    </span>
  }
  @case ('paid') {
    <span
      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300 whitespace-nowrap"
    >
      Bezahlt
    </span>
  }
  @case ('canceled') {
    <span
      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-pink-100 dark:bg-pink-900/50 text-pink-800 dark:text-pink-300 whitespace-nowrap"
    >
      Storniert
    </span>
  }
}
